import React from 'react'
import cn from 'classnames'
import { useDropdown } from '@hooks/useDropdown'
import { ChevronDownIcon } from '@components/icons/ChevronDownIcon'
import { SortOptionType } from '@interfaces/SortOptionType'

const defaultOptions = [
  { value: 'updatedAt:desc', title: 'เรียงตาม', label: 'ใหม่ - เก่า' },
  { value: 'book.price:desc', title: 'เรียงตามราคา', label: 'ราคามาก - น้อย' },
  {
    value: 'book.likeCount:desc',
    title: 'เรียงตามความนิยม',
    label: 'นิยมมาก - น้อย',
  },
]
interface SortInputProps {
  value: string
  isShowLabel?: boolean
  className?: string
  onChange: (value: any) => void
  options?: SortOptionType[]
  dataTest?: string
}

const SortInput = ({
  value,
  className,
  onChange,
  options,
  isShowLabel,
  dataTest,
}: SortInputProps) => {
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()

  const sortOptions: SortOptionType[] = options || defaultOptions

  return (
    <div data-test='sort' className={cn('relative select-none', className)}>
      {isShowLabel && (
        <div className='text-[12px] text-secondary-1 dark:text-dark-10 font-light mb-[4px]'>
          เรียงตาม
        </div>
      )}
      <div
        ref={dropdownRef}
        data-test={dataTest}
        className={cn(
          'w-full h-[40px] border-[1px] rounded-[8px] text-[14px]  dark:text-dark-10 text-secondary dark:bg-dark-8 font-medium p-[10px] cursor-pointer',
          {
            'border-primary': isShowDropdown,
            'border-gray-3 dark:border-purple': !isShowDropdown,
          }
        )}
        onClick={toggleDropdown}
      >
        <div className='flex items-center justify-between font-light'>
          <div className='flex space-x-[5px]'>
            <span className='text-secondary-1'>
              {sortOptions?.find(row => row.value === value)?.title ||
                'เรียงตาม'}
              :
            </span>
            <span className='font-bold'>
              {sortOptions?.find(row => row.value === value)?.label ||
                'เรียงตาม'}
            </span>
          </div>
          <ChevronDownIcon className='text-primary w-[16px] h-[16px]' />
        </div>
        <div
          className={cn(
            'absolute w-full z-10 mt-[15px] right-0 bg-white dark:bg-dark-8 border border-gray-4 dark:border-purple rounded-[8px] max-h-[300px] overflow-y-auto shadow-dropdown',
            { hidden: !isShowDropdown }
          )}
        >
          <div data-test='sort-list' className='my-[10px]'>
            {sortOptions.map((menu, index) => (
              <div
                className='font-light py-[6px] px-[15px] hover:bg-primary-1 dark:hover:bg-dark hover:text-primary dark:hover:text-dark-10'
                key={index}
                data-test={`sort-${menu.label}`}
                onClick={() => onChange(menu.value)}
              >
                {`${menu.title} : `}
                <span className='font-bold'>{menu.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SortInput
